/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainComplaintStatusType = 'Open' | 'InProgress' | 'Closed' | 'Withdrawn';

export const DomainComplaintStatusType = {
    Open: 'Open' as DomainComplaintStatusType,
    InProgress: 'InProgress' as DomainComplaintStatusType,
    Closed: 'Closed' as DomainComplaintStatusType,
    Withdrawn: 'Withdrawn' as DomainComplaintStatusType
};